module.exports = __webpack_public_path__ + "img/CTWP__Espadon.86fbc661.png";